
import MainLayout from "@/components/layout/MainLayout";

const Privacidade = () => {
  return (
    <MainLayout showSidebar={false}>
      <div className="container mx-auto py-12 px-4">
        <h1 className="text-3xl font-bold mb-8">Política de Privacidade</h1>
        
        <div className="prose max-w-none">
          <p className="mb-4">Última atualização: 14 de Maio de 2025</p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">1. Introdução</h2>
          <p className="mb-4">
            O Vive Calme está comprometido com a proteção de sua privacidade. Esta política descreve 
            como coletamos, usamos e protegemos suas informações pessoais em conformidade com a Lei Geral 
            de Proteção de Dados (LGPD) do Brasil.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">2. Informações que Coletamos</h2>
          <p className="mb-4">
            Coletamos informações que você fornece diretamente, incluindo detalhes de conta, informações 
            de perfil e conteúdo das conversas. Também coletamos dados técnicos como endereço IP, tipo de 
            navegador e interações com o serviço.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">3. Uso de Informações</h2>
          <p className="mb-4">
            Utilizamos suas informações para fornecer e melhorar nossos serviços, personalizar sua 
            experiência, processar pagamentos e cumprir obrigações legais.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">4. Compartilhamento de Dados</h2>
          <p className="mb-4">
            Não vendemos seus dados pessoais. Compartilhamos informações apenas com fornecedores de 
            serviços que nos ajudam a operar, como processadores de pagamento e serviços de hospedagem.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">5. Segurança de Dados</h2>
          <p className="mb-4">
            Implementamos medidas técnicas e organizacionais para proteger suas informações contra 
            acesso não autorizado, alteração, divulgação ou destruição.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">6. Seus Direitos</h2>
          <p className="mb-4">
            Você tem o direito de acessar, corrigir, excluir e portar seus dados pessoais. Também pode 
            restringir ou se opor ao processamento em determinadas circunstâncias.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">7. Cookies e Tecnologias Semelhantes</h2>
          <p className="mb-4">
            Utilizamos cookies e tecnologias similares para melhorar a experiência do usuário e coletar 
            dados sobre o uso do site. Você pode gerenciar suas preferências de cookies nas configurações 
            da sua conta.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">8. Alterações a esta Política</h2>
          <p className="mb-4">
            Podemos atualizar esta política periodicamente. Notificaremos sobre alterações significativas 
            através de um aviso em nosso site ou por e-mail.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">9. Contato</h2>
          <p className="mb-4">
            Para questões relacionadas à sua privacidade, entre em contato com nosso Encarregado de 
            Proteção de Dados através do email: privacidade@vivecalme.com
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

export default Privacidade;
